import { Injectable } from "@angular/core";
import { LanguageResolver, LanguageResolverType } from "../language-resolver";
import { IMSObject } from "src/app/_model/ims-object";
import { LoggingService } from "../../logging/logic/logging.service";
import { ClientStateService } from "../../client-state/logic/client-state.service";
import { TranslateService } from "@ngx-translate/core";
import { BranchesService } from "../../branches/logic/branches.service";
import { Servicejob } from "src/app/_model/servicejob";
import { DeficiencyTicket } from "src/app/_model/deficiency-ticket";
import { TourStop } from "src/app/_model/tour-stop";
import { Branch } from "src/app/_model/branches";

@Injectable({
  providedIn: 'root',
})
export class BranchCustom1Resolver implements LanguageResolver {
  // Public Member
  public readonly name: LanguageResolverType = 'branch-custom1';

  // Lifecycle
  constructor(
    private logger: LoggingService,
    private translate: TranslateService,
    private clientStateService: ClientStateService,
    private branchesService: BranchesService,
  ) {}

    public async resolveLanguage(object: IMSObject): Promise<string> {
        const branch = await this.getBranchOfObject(object)
        const locale: string = branch?.getValueFromDatabag("custom1")
        if (locale == undefined ||locale === "") {
            return this.translate.currentLang
        }
        return locale.toLowerCase()
    }

    private async getBranchOfObject(object: IMSObject): Promise<Branch> {
        this.logger.log(this.constructor.name,  "checking for custom1 on branch of object", object.id.objRef, object.id.imsId)
        if (object.id.objRef === 'ims/Branch') {
            this.logger.log(this.constructor.name,  "Retrieving custom1 from branch")
            return object as Branch
        } else if (object.id.objRef === 'ims/ServiceJob') {
            const sjob = object as Servicejob
            this.logger.log(this.constructor.name,  "Retrieving custom1 from branch via sjob", sjob?.name, sjob.branch?.id)
            return this.branchesService.getBranchById(sjob.branch?.id)
        } else if (object.id.objRef === 'ims/DeficiencyTicket') {
            const deficiencyTicket = object as DeficiencyTicket
            if (deficiencyTicket?.ownerObjRef === "ims/Branch") {
                this.logger.log(this.constructor.name, "Retrieving custom1 from branch via deficiencyticket", deficiencyTicket?.owner?.id)
                return this.branchesService.getBranchById(deficiencyTicket.owner.id)
            }
        } else if (object.id.objRef === "ims/TourStop") {
            const tourStop = object as TourStop
            this.logger.log(this.constructor.name, "Retrieving custom1 from tourstop via deficiencyticket", tourStop?.id, tourStop.branchIds?.[0])
            return this.branchesService.getBranchById(tourStop.branchIds?.[0])
        }
    }

}